<template>
    <div class="d-flex justify-content-start align-items-center  no-gutters">
        <div class="">
            <v-autocomplete :id="'year' + _uid" :ref="'year' + _uid" :items="years" v-model="selectedYear"
                            no-data-text="لا يوجد" label="السنة" append-icon="mdi-chevron-down" solo hide-details
                            height="50" style="width: 110px;" class="rounded-0" maxlength="4" @click.stop="" @keypress="isNumber($event)"
                            @change="onSelectedYearChange">
            </v-autocomplete>
        </div>
        <div class="col-6">
            <v-autocomplete :id="'month' + _uid" :items="months" item-value="value" item-text="name"
                            no-data-text="لا يوجد" label="الشهر" return-object solo hide-details autocomplete="off"
                            height="50" class="rounded-0 wide-input" maxlength="2" append-icon="mdi-chevron-down" v-model="selectedMonth"
                            @click.stop="" @change="onSelectedMonthChange">
            </v-autocomplete>
        </div>
        <div class="">
            <v-autocomplete :id="'day' + _uid" :ref="'day' + _uid" :items="days" label="اليوم"
                            no-data-text="لا يوجد" return-object hide-details solo height="50" style="width: 110px;" class="rounded-0"
                            maxlength="2" append-icon="mdi-chevron-down" v-model="selectedDay" @click.stop="" @keypress="isNumber($event)"
                            @change="onSelectedDayChange">
            </v-autocomplete>
        </div>
        <span v-if="isConditionControl && !isValid" style="color:#f75555">الحقل مطلوب</span>
    </div>
 
</template>
<script lang="ts">
    import { Watch, Prop, Component, Vue } from "vue-property-decorator";
    import moment from 'moment';
    import { DDCalendarDate } from '@/models/common';
    //@ts-ignore
    import momenthijri from 'moment-hijri';

    interface SelectedMonth {
        name: string;
        value: number;
    }

    @Component({
        components: {
        },
    })
    export default class datePickerComponent extends Vue {
        @Prop({ default: '' }) label!: string;
        @Prop({ default: 100 }) yearsCount!: number;
        @Prop({ default: 0 }) futureYearsCount!: number;
        @Prop({ default: false }) isGregorian!: boolean;
        @Prop({ default: '' }) date!: string;
        @Prop({ default: false }) isRequired!: boolean;
        @Prop({ default: '' }) maxDate!: string;
        @Prop({ default: '' }) minDate!: string;
        @Prop({ default: false }) isConditionControl!: string;
        @Prop({ default: -1 }) index!: number;
        @Prop({ default: null }) selectedDateCal!: DDCalendarDate | null;
        isValid = true;
        maxDateInternal = '';
        minDateInternal = '';
        miniYear = 0;
        isGregorianInternal = false;
        intSelectedDate = new Date();
        currentDate = '';
        years = [] as number[];
        months = [] as SelectedMonth[];
        days = [] as number[];
        selectedYear = null as number | null;
        selectedMonth = null as SelectedMonth | null;
        selectedDay = null as number | null;
        bindedDate = '';
        gregorianMonths = [
            'يناير - 1',
            'فبراير - 2',
            'مارس - 3',
            'أبريل - 4',
            'مايو - 5',
            'يونيو - 6',
            'يوليو - 7',
            'أغسطس - 8',
            'سبتمبر - 9',
            'أكتوبر - 10',
            'نوفمبر - 11',
            'ديسمبر - 12',
        ];
        hijriMonths = [
            'محرّم - 1',
            'صفر - 2',
            'ربيع الأول - 3',
            'ربيع الآخر - 4',
            'جمادى الأول - 5',
            'جمادى الآخر - 6',
            'رجب - 7',
            'شعبان - 8',
            'رمضان - 9',
            'شوّال - 10',
            'ذو القعدة - 11',
            'ذو الحجة - 12',
        ];
        autoCompleteMonthStyle = 'width: 10vw !important;';
        mounted() {
            moment.locale('en-us');
            this.minDateInternal = this.minDate;
            //@ts-ignore
            this.$refs['day' + this._uid].lastItem = 31;
            if (this.isGregorian) {
                this.currentDate = moment().format('YYYY-MM-DD');
            } else {
                this.currentDate = momenthijri().format('iYYYY-iMM-iDD');
            }
            this.setMaxDateInternal();
            this.generateDate();
        }
        beforeUpdate() {
            moment.locale('en-us');
            this.minDateInternal = this.minDate;
            //@ts-ignore
            this.$refs['day' + this._uid].lastItem = 31;
            if (this.isGregorian) {
                this.currentDate = moment().format('YYYY-MM-DD');
            } else {
                this.currentDate = momenthijri().format('iYYYY-iMM-iDD');
            }
            this.setMaxDateInternal();
            this.generateDate();
        }
        setMaxDateInternal() {
            if (this.maxDate.trim().toLowerCase() != '') {
                if (this.maxDate.toLowerCase() == 'today') {
                    this.maxDateInternal = this.isGregorian ?
                        moment().format('YYYY-MM-DD') : momenthijri().format('iYYYY-iMM-iDD');
                }
                else {
                    this.maxDateInternal = this.isGregorian ?
                        moment(this.maxDate.trim(), 'yyyy-MM-dd').format('YYYY-MM-DD') : moment(this.maxDate.trim(), 'yyyy-MM-dd').format('iYYYY-iMM-iDD');
                }
            }
            else if (this.futureYearsCount > 0) {
                let currentYear = Number.parseInt(this.currentDate.split('-')[0], 10);
                if (this.isGregorian === true) {
                    this.maxDateInternal = currentYear + this.futureYearsCount + '-12-31'
                }
                else {
                    this.maxDateInternal = currentYear + this.futureYearsCount + '-12-30'
                }
            }
        }
        generateDate() {

            this.generateYears();
            //@ts-ignore
            this.$refs['year' + this._uid].lastItem = this.years.length;
            this.generateMonths();
            if (this.selectedDateCal) {
                const selectedDate = this.isGregorian ? this.selectedDateCal.gregDate : this.selectedDateCal.hijriDate;
                if (selectedDate != '') {
                    var splitted = selectedDate.split('-');
                    if (splitted && this.isGregorian) {
                        this.selectedYear = parseInt(splitted[0]);
                        this.selectedMonth = {} as SelectedMonth;
                        this.selectedMonth.value = parseInt(splitted[1]);
                        var name = this.gregorianMonths.find(x => {
                            if (this.selectedMonth) {
                                var monthNumber = this.selectedMonth.value.toString().startsWith('0') ? this.selectedMonth.value.toString()[1] : this.selectedMonth.value.toString();
                                return x.includes(monthNumber);
                            }
                        });
                        if (name) {
                            this.selectedMonth.name = name;
                        }
                        this.getDays(this.selectedMonth.value, this.selectedYear);
                        this.selectedDay = parseInt(splitted[2]);
                    }
                    else {
                        this.selectedYear = parseInt(splitted[0]);
                        this.selectedMonth = {} as SelectedMonth;
                        this.selectedMonth.value = parseInt(splitted[1]);
                        var name = this.hijriMonths.find(x => {
                            if (this.selectedMonth) {
                                var monthNumber = this.selectedMonth.value.toString().startsWith('0') ? this.selectedMonth.value.toString()[1] : this.selectedMonth.value.toString();
                                return x.includes(monthNumber);
                            }
                        });
                        if (name) {
                            this.selectedMonth.name = name;
                        }
                        this.getDays(this.selectedMonth.value, this.selectedYear);
                        this.selectedDay = parseInt(splitted[2]);
                    }

                }
            }
        }
        generateYears() {
            this.years = [];
            let year = Number.parseInt(this.currentDate.split('-')[0], 10);

            this.miniYear = Number.parseInt(this.minDateInternal.split('-')[0], 10);
            let maxYear = year + this.futureYearsCount;
            for (var i = this.miniYear; i <= maxYear; i++) {
                this.years.unshift(i);
            }
            let minYear = Number.parseInt(this.minDateInternal.split('-')[0], 10);
            let minMonth = Number.parseInt(this.minDateInternal.split('-')[1], 10);
            let minDay = Number.parseInt(this.minDateInternal.split('-')[2], 10);
            this.years = this.years.filter(function (yr, idx) {
                return yr >= minYear;
            });
        }
        generateMonths() {
            this.months = [];
            const { isGregorian, hijriMonths, gregorianMonths } = this;
            const { maxDateInternal, minDateInternal, selectedYear } = this;
            const [maxYear, maxMonth] = maxDateInternal.split('-').map(Number);

            for (let i = 1; i <= 12; i++) {
                const name = isGregorian ? gregorianMonths[i - 1] : hijriMonths[i - 1];
                const value = i;
                this.months.push({ name, value });
            }

            if (maxDateInternal) {
                if (selectedYear === maxYear) {
                    this.months = this.months.filter(m => m.value <= maxMonth);
                }
            }
            if (minDateInternal) {
                const minDateGreg = this.minDateInternal;
                const [minYear, minMonth, minDay] = minDateGreg.split('-').map(Number);
                if (selectedYear === minYear) {
                    this.months = this.months.filter(m => m.value >= minMonth);
                }
            }
        }

        getDays(month: number | null, year: number) {
            if (this.selectedMonth === null || this.selectedMonth === undefined) {
                return;
            }
            this.days = [];
            let daysCount = 0;
            let maxDay = 0;
            let maxYear = 0;
            let maxMonth = 0;

            if (this.maxDateInternal != '') {
                maxDay = Number.parseInt(this.maxDateInternal.split('-')[2], 10);
                maxYear = Number.parseInt(this.maxDateInternal.split('-')[0], 10);
                maxMonth = Number.parseInt(this.maxDateInternal.split('-')[1], 10);
                if (this.selectedYear == maxYear && month == maxMonth) {
                    daysCount = maxDay;
                }
                else {
                    if (this.isGregorian) {
                        daysCount = moment(year + '-' + month, 'yyyy-MM').daysInMonth();
                    } else {
                        daysCount = 30;
                    }
                }
            }

            while (daysCount >= 1) {
                this.days.push(daysCount);
                daysCount--;
            }
            if (this.minDateInternal != '') {
                let minYear = Number.parseInt(this.minDateInternal.split('-')[0], 10);
                let minMonth = Number.parseInt(this.minDateInternal.split('-')[1], 10);
                let minDay = Number.parseInt(this.minDateInternal.split('-')[2], 10);
                if (month === minMonth && year === minYear) {
                    this.days = this.days.filter(function (d, idx) {
                        return d >= minDay;
                    });
                }
            }
        }
        @Watch('isGregorianInternal')
        calendarTypeChange() {
            if (this.isGregorian) {
                this.currentDate = moment().format('YYYY-MM-DD');
            } else {
                this.currentDate = momenthijri().format('iYYYY-iMM-iDD');
            }
            this.generateYears();
            this.generateMonths();
            this.getDays(Number.parseInt(this.currentDate.split('-')[1], 10)
                , Number.parseInt(this.currentDate.split('-')[0], 10));
            this.fillDates();

            this.$emit("calendarTypeChanged", this.isGregorian);
        }

        fillDates() {
            if (this.selectedYear && this.selectedMonth && this.selectedDay) {
                let selectedDate = this.selectedYear + '-' + this.selectedMonth.value + '-' + this.selectedDay;
                if (this.isGregorian) {
                    let selectedGregDate = momenthijri(selectedDate, 'iYYYY-iMM-iDD').format('YYYY-MM-DD');
                    this.selectedYear = Number.parseInt(selectedGregDate.split('-')[0]);
                    this.selectedMonth = this.months.find((x) =>
                        x.value === Number.parseInt(selectedGregDate.split('-')[1], 10)) as any;
                    this.selectedDay = Number.parseInt(selectedGregDate.split('-')[2]);
                }
                else {
                    let selectedHijDate = momenthijri(selectedDate, 'YYYY-MM-DD').format('iYYYY-iMM-iDD');
                    if (selectedHijDate == "1355-12-NaN") {
                        this.selectedYear = 0;
                        this.selectedMonth = null;
                        this.selectedDay = 0;
                    }
                    else {
                        this.selectedYear = Number.parseInt(selectedHijDate.split('-')[0]);
                        this.selectedMonth = this.months.find((x) =>
                            x.value === Number.parseInt(selectedHijDate.split('-')[1], 10)) as any;
                        this.selectedDay = Number.parseInt(selectedHijDate.split('-')[2]);
                    }
                }
            }
            else {
                this.selectedYear = null;
                this.selectedMonth = null;
                this.selectedDay = null;
            }

            let changedDate: DDCalendarDate = {
                isGregorian: this.isGregorian,
                gregDate: '',
                hijriDate: '',
                date: new Date(Date.now())
            };

            if (this.selectedYear && this.selectedMonth && this.selectedMonth.value !== 0 && this.selectedDay) {
                let selectedDate = this.selectedYear + '-' + this.selectedMonth.value.toString().padStart(2, '0') + '-' + this.selectedDay.toString().padStart(2, '0');
                if (!this.isGregorian) {
                    let selectedGregDate = momenthijri(selectedDate, 'iYYYY-iMM-iDD').format('YYYY-MM-DD');
                    if (selectedGregDate != "1001-03-01")
                        changedDate.gregDate = selectedGregDate;
                    changedDate.hijriDate = selectedDate;
                }
                else {
                    let selectedHijDate = momenthijri(selectedDate, 'YYYY-MM-DD').format('iYYYY-iMM-iDD');
                    if (selectedHijDate != "1355-12-NaN")
                        changedDate.hijriDate = selectedHijDate;
                    changedDate.gregDate = selectedDate;
                }
            }
            if (!this.isConditionControl) {
                this.$emit('dateChanged', changedDate);
            }
            else {
                if (changedDate.hijriDate == '' || changedDate.gregDate == '') {
                    this.isValid = false;
                }
                else {
                    this.isValid = true;
                }
                this.$emit('controlDataChanged', { value: changedDate, index: this.index, isValid: this.isValid });
            }



        }

        onSelectedYearChange(Year: number) {
            this.selectedMonth = null;
            this.selectedDay = null;
            this.generateMonths();
            this.updateChangedDate();
        }
        onSelectedMonthChange(selectedMonth: any) {
            this.selectedDay = null;
            this.getDays(selectedMonth.value, this.selectedYear as number);
            this.updateChangedDate();
        }
        onSelectedDayChange(day: string) {
            this.updateChangedDate();
        }
        updateChangedDate() {
            let changedDate: DDCalendarDate = {
                isGregorian: this.isGregorian,
                gregDate: '',
                hijriDate: '',
                date: new Date(Date.now())
            };

            if (this.selectedYear && this.selectedMonth && this.selectedMonth.value !== 0 && this.selectedDay) {
                let selectedDate = this.selectedYear + '-' + this.selectedMonth.value.toString().padStart(2, '0') + '-' + this.selectedDay.toString().padStart(2, '0');
                if (!this.isGregorian) {
                    let selectedGregDate = momenthijri(selectedDate, 'iYYYY-iMM-iDD').format('YYYY-MM-DD');
                    if (selectedGregDate != "1001-03-01")
                        changedDate.gregDate = selectedGregDate;
                    changedDate.hijriDate = selectedDate;
                }
                else {
                    let selectedHijDate = momenthijri(selectedDate, 'YYYY-MM-DD').format('iYYYY-iMM-iDD');
                    if (selectedHijDate != "1355-12-NaN")
                        changedDate.hijriDate = selectedHijDate;
                    changedDate.gregDate = selectedDate;
                }
            }
            if (!this.isConditionControl) {
                if (changedDate.gregDate !== null && changedDate.gregDate !== '' && changedDate.gregDate !== undefined) {
                    this.$emit('dateChanged', changedDate);
                }
            }
            else {
                if (changedDate.hijriDate == '' || changedDate.gregDate == '') {
                    this.isValid = false;
                }
                else {
                    this.isValid = true;
                }
                this.$emit('controlDataChanged', { value: changedDate, index: this.index, isValid: this.isValid });
            }


        }

        isNumber(evt: any) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        }
        clear() {
            this.selectedYear = null;
            this.selectedMonth = null;
            this.selectedDay = null;
            this.months = [];
            this.days = [];
        }

        resetYears() {

            this.generateYears();
            //@ts-ignore
            this.$refs['year' + this._uid].lastItem = this.years.length;
        }

        setToday() {
            const today = this.isGregorian ? moment().format('YYYY-MM-DD') : momenthijri().format('iYYYY-iMM-iDD');
            const currentYear = Number.parseInt(today.split('-')[0], 10);
            const currentMonth = Number.parseInt(today.split('-')[1], 10);
            const currentDay = Number.parseInt(today.split('-')[2], 10);
            this.selectedYear = currentYear;
            this.generateMonths();
            this.selectedMonth = {} as SelectedMonth;
            this.selectedMonth = this.months.find((x) => x.value === currentMonth) as any;
            this.getDays(this.selectedMonth?.value ?? null, this.selectedYear as number);
            this.selectedDay = currentDay;

            this.updateChangedDate();
        }
    }
</script>

<style lang="scss" scoped>
.dd-calendar .v-input__control .v-input__icon--append i.mdi {
  color: var(--v-primary-base);
}

.wide-input div[role='combobox'] {
  padding: 0 8px !important;
}

.dd-calendar .dd-switch-aligned {
  margin-top: 5px;
}

.dd-calendar .rounded-0 .v-input__control .v-input__slot>fieldset {
  border-color: #e4e5e6;
}

.dd-calendar .v-input__append-inner {
  margin-top: 14px !important;
  cursor: pointer;
}

.dd-calendar .v-select__slot .v-label {
  margin-top: 5px !important;
}

    .v-field__append-inner {
        cursor:pointer !important;
    }
          .v-selection-control--density-default {
              --v-selection-control-size: -1px !important;
          }

    .mdi-chevron-down {
        display:none !important;
    }
    .autocomplete-overlay .v-input--dirty {
        font-size: 0.7rem !important;
    }
</style>